// hooks/useAgents.js
import { useState, useEffect, useCallback } from "react";
import { IBA_Admin_Section } from "../../../Configuration/API_URL";
import { axiosInstance0 } from "../../../CommonMethhods/axiosInstance";

export function useAgents() {
  const [agents, setAgents] = useState([]);
  // const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  // const [scrollLoading, setScrollLoading] = useState(false);
  // const [totalAgents, setTotalAgents] = useState(0);
  

  //Fetch agents API call
  const fetchAgents = useCallback(
    async (payload = {searchKey: ""}) => {
      try {
        setLoading(true);

        let response = await axiosInstance0.post(
          IBA_Admin_Section.agentPayoutList,
          payload,
        );

        response = response.data;

        if (response?.status === 0) {
          // setTotalAgents(response.data?.count || 0);
          setAgents(response?.data || []);

          // if (pageParam > 1) {
          //   setAgents((prev) => [...prev, ...(response?.data?.agents ?? [])]);
          // } else {
          //   setAgents(response?.data?.agents ?? []);
          // }
        } else {
          setAgents([]);
        }
      } catch (error) {
        console.error("Error fetching agents:", error);
        setAgents([]);
      } finally {
        setLoading(false);
      }
    },
    []
  );

  //Load first page on mount/status change
  useEffect(() => {
    fetchAgents();
  }, [fetchAgents]);

  // Infinite scroll handler
  // const handleScroll = (e) => {
  //   const el = e.target;
  //   const scrolledToBottom =
  //     el.scrollTop + el.offsetHeight + 1 >= el.scrollHeight;

  //   if (scrolledToBottom && !scrollLoading) {
  //     const nextPage = page + 1;
  //     const totalLoaded = page * limit;

  //     if (totalAgents > totalLoaded && totalAgents !== agents.length) {
  //       setPage(nextPage);
  //       setScrollLoading(true);
  //       fetchAgents({ pageParam: nextPage });
  //     }
  //   }
  // };

  // Search
  const handleSearch = (value) => {
    // setPage(1);
    fetchAgents({search: value });
  };

  return {
    agents,
    setAgents,
    loading,
    // scrollLoading,
    // totalAgents,
    // page,
    // setPage,
    fetchAgents,
    // handleScroll,
    handleSearch,
  };
}
